export function setMiniHeaderTheme(miniHeaderEl, activeSlide) {
  if (!miniHeaderEl || !activeSlide) return;

  if (
    activeSlide.classList.contains('template-history') ||
    activeSlide.classList.contains('archive-artist') ||
    activeSlide.classList.contains('template-map-dark')
  ) {
    miniHeaderEl.classList.add('overlay-header-mini--dark');
  } else {
    miniHeaderEl.classList.remove('overlay-header-mini--dark');
  }
}

export function renderMiniHeader(miniHeaderEl, { closeEl, titleEl, paginationEl }) {
  if (!miniHeaderEl) return { close: null, title: null, pagination: null };

  miniHeaderEl.innerHTML = '';

  const close = closeEl ? closeEl.cloneNode(true) : null;
  const title = titleEl ? titleEl.cloneNode(true) : null;
  const pagination = paginationEl ? paginationEl.cloneNode(true) : null;

  if (title && title.classList) {
    Array.from(title.classList).forEach((cls) => {
      if (/^m[trbl]-\d+$/.test(cls) || /^p[trbl]-\d+$/.test(cls)) {
        title.classList.remove(cls);
      }
    });
  }

  if (close) miniHeaderEl.append(close);
  if (title) miniHeaderEl.append(title);
  if (pagination) miniHeaderEl.append(pagination);

  return { close, title, pagination };
}

export function syncPaginationBullets(paginationEl, activeIndex) {
  if (!paginationEl) return;
  const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
  bullets.forEach((b) => b.classList.remove('swiper-pagination-bullet-active'));
  if (bullets[activeIndex]) bullets[activeIndex].classList.add('swiper-pagination-bullet-active');
}

